module.exports = __webpack_public_path__ + "media/images/homes/discount2x-900cd8d67aded0a88d2285f21169efc5.png";